export const pageUrlSegment: string = 'page';
